import React, { useState, useEffect } from "react";
import AwardsBanner from "../../../assets/images/AwardsBannerNew.png";
import AwardsCard from "../../CustomComponent/AwardsCard.tsx";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";
import styles from "./AwardsAndAchievement.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { allAwardsData } from "../../../redux/slices/awardsSlice.js";
import nextPagination from "../../../assets/images/nextPagination.png";
import backPagination from "../../../assets/images/backPagination.png";
import { motion } from "framer-motion";

const content = [
  `Aptech has consistently been recognized internationally for being a leading vocational training provider delivering quality education and offering robust career growth opportunities to students and professionals worldwide. Aptech’s achievements reflect the company’s influence in vocational training across various industries, empowering students to build successful careers.`,
  `Over the years, Aptech has received several awards and recognitions
            that have positioned the company as a global leader in fields such
            as IT, finance, animation, beauty and wellness, aviation and hospitality.`,
];

const AwardsAndAchievement: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Awards at Aptech", link: "" },
  ];

  const [filteredAwards, setFilteredAwards] = useState();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 6;
  const totalPages = Math.ceil(filteredAwards?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchNewseData = async () => {
      try {
        const awardData = { brand: "AWW" };
        const data = await dispatch(allAwardsData(awardData)).unwrap();
        console.log(data, "data");
        setFilteredAwards(data?.awards || []);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      }
    };
    fetchNewseData();
  }, [dispatch]);

  const paginatedData = filteredAwards?.slice(startIndex, endIndex);

  const startYear = 2015;
  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  const createPagination = () => {
    let str: JSX.Element[] = [];
    let pageCutLow = currentPage - 1;
    let pageCutHigh = currentPage + 1;

    if (currentPage > 1) {
      str.push(
        <li key="prev" className={`${styles.pageItem} ${styles.previous}`}>
          <a onClick={() => setCurrentPage(currentPage - 1)}>
            <img src={backPagination} alt="backPagination" />
          </a>
        </li>
      );
    }

    if (totalPages < 6) {
      for (let p = 1; p <= totalPages; p++) {
        str.push(
          <li
            key={p}
            className={`${styles.pageItem} ${
              currentPage === p ? styles.active : ""
            }`}
          >
            <a onClick={() => setCurrentPage(p)}>{p}</a>
          </li>
        );
      }
    } else {
      if (currentPage > 2) {
        str.push(
          <li key="first" className={styles.pageItem}>
            <a onClick={() => setCurrentPage(1)}>1</a>
          </li>
        );
        if (currentPage > 3) {
          str.push(
            <li key="dots-prev" className={styles.outOfRange}>
              <a onClick={() => setCurrentPage(currentPage - 2)}>...</a>
            </li>
          );
        }
      }

      if (currentPage === 1) {
        pageCutHigh += 2;
      } else if (currentPage === 2) {
        pageCutHigh += 1;
      }
      if (currentPage === totalPages) {
        pageCutLow -= 2;
      } else if (currentPage === totalPages - 1) {
        pageCutLow -= 1;
      }

      for (let p = pageCutLow; p <= pageCutHigh; p++) {
        if (p > 0 && p <= totalPages) {
          str.push(
            <li
              key={p}
              className={`${styles.pageItem} ${
                currentPage === p ? styles.active : ""
              }`}
            >
              <a onClick={() => setCurrentPage(p)}>{p}</a>
            </li>
          );
        }
      }

      if (currentPage < totalPages - 1) {
        if (currentPage < totalPages - 2) {
          str.push(
            <li key="dots-next" className={styles.outOfRange}>
              <a onClick={() => setCurrentPage(currentPage + 2)}>...</a>
            </li>
          );
        }
        str.push(
          <li key="last" className={styles.pageItem}>
            <a onClick={() => setCurrentPage(totalPages)}>{totalPages}</a>
          </li>
        );
      }
    }

    if (currentPage < totalPages) {
      str.push(
        <li key="next" className={`${styles.pageItem} ${styles.next}`}>
          <a onClick={() => setCurrentPage(currentPage + 1)}>
            <img src={nextPagination} alt="nextPagination" />
          </a>
        </li>
      );
    }

    return str;
  };

  return (
    <div className={`${styles.AwardsWithAptech}`}>
      {/* Breadcrumb (No Animation) */}
      <BreadCrumb menu={breadcrumb} />

      <div className="container">
        {/* Section 1: ImageTextSection */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
          viewport={{ once: true }}
          className="section"
        >
          <div className="row mt-5">
            <div className="col-12">
              <ImageTextSection
                imageSrc={AwardsBanner}
                imageAlt="WhyAptech Image"
                content={content}
                heading="Global Awards and Achievement"
                reverse={true}
              />
            </div>
          </div>
        </motion.div>

        {/* Section 2: Awards Listing */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
          viewport={{ once: true }}
          className="section"
        >
          <div className="row g-4">
            <p className="heading mb-lg-4 mb-md-3 mb-4">
              Prestigious Awards won by Aptech
            </p>

            {paginatedData?.map((award, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-4 col-sm-12 mb-lg-4 mb-md-3 mb-0 mt-lg-2 mt-md-3 mb-0 mt-0 d-flex flex-column justify-content-center h-50"
              >
                <AwardsCard
                  awardImage={award?.main_img}
                  description={award?.short_description}
                />
              </div>
            ))}
          </div>
          <div className={styles.pagination}>
            <ul className={`${styles.ulContainer} ${styles.paginationList}`}>
              {createPagination()}
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AwardsAndAchievement;
